import { motion } from "framer-motion";
import { Users, Mic, ShieldCheck, Sparkles } from "lucide-react";

const highlights = [
  {
    icon: Users,
    title: "Curated 1:1 ratio",
    description: "Every event has equal men and women. Verified profiles ensure quality over quantity.",
  },
  {
    icon: Mic,
    title: "Hosted & structured",
    description: "A professional host leads the evening — icebreakers, games, and mini-dates so no one sits alone.",
  },
  {
    icon: ShieldCheck,
    title: "Safety-first design",
    description: "18+ with ID verification, clear code of conduct, and partner venue security. Always.",
  },
  {
    icon: Sparkles,
    title: "Real chemistry, offline",
    description: "No filters, no curated bios. Just real conversations, shared laughs, and genuine connection.",
  },
];

export default function WhyDifferent() {
  return (
    <section
      className="py-24 sm:py-32 bg-muted/50"
      data-testid="why-different-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <p className="font-mono text-xs tracking-[0.2em] uppercase font-semibold text-[hsl(var(--accent))] mb-4">
            Why Cita Rush
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight font-medium max-w-2xl">
            Not another dating app.
            <br />
            <span className="text-muted-foreground">This is real life.</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-6 lg:gap-8">
          {highlights.map((item, i) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`why-different-card-${i + 1}`}
            >
              <div className="bg-card border border-border/40 rounded-sm p-8 h-full shadow-[0_8px_30px_rgb(0,0,0,0.04)] dark:shadow-none transition-all duration-300 hover:-translate-y-1">
                <div className="w-10 h-10 rounded-sm bg-secondary flex items-center justify-center mb-5">
                  <item.icon className="w-5 h-5 text-[hsl(var(--accent))]" strokeWidth={1.5} />
                </div>
                <h3 className="font-heading text-xl tracking-tight font-medium mb-2">
                  {item.title}
                </h3>
                <p className="text-base leading-relaxed text-muted-foreground">
                  {item.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
